"use client";

import dynamic from "next/dynamic";
import { usePricingModal } from "../hooks/usePricingModal";

// Fetched on first open — the modal is mounted in the root layout, and its
// cards (with their billing logic) have no business in every route's first load.
const PricingModal = dynamic(
  () => import("@/components/layout/header/PricingModal").then((m) => m.PricingModal),
  { ssr: false },
);

export function GlobalPricingModal() {
  const { isOpen, everOpened, close, highlight, source } = usePricingModal();
  if (!everOpened) return null;
  return <PricingModal isOpen={isOpen} onClose={close} highlight={highlight} source={source} />;
}
